(function ($) {
  var isIE = false;

  Drupal.behaviors.productGridToutBasicV1 = {
    init: function ($wrapper) {
      var $this;
      var breakpoint = 768;
      var $loopingVid;
      var $loopingVidWrapper;
      var hasLoopingVid = false;
      var mobileVideo = false;
      var desktopVideo = false;
      var desktopVidSrc;
      var mobVidSrc;

      $wrapper.each(function () {
        $this = $(this);
        /*
        /--------------------------------------------------------------------------
        / Inline Looping Video.
        /--------------------------------------------------------------------------
        / Global vars (for this behaviour).
        / Check if a looping video is present.
        / Video functionality - mute/unmute etc.
        */

        $loopingVid = $this.find('.looping_vidContent');
        $loopingVidWrapper = $loopingVid.closest('.autoplay_video');
        var $modPicSrs = $loopingVidWrapper.siblings('.module_block__imgs');

        // Check if a looping video is present
        mobileVideo = $loopingVid.attr('data-mob-src') !== '';
        desktopVideo = $loopingVid.attr('data-desktop-src') !== '';
        hasLoopingVid = mobileVideo || desktopVideo;

        // Begin main video functionality.
        if (hasLoopingVid) {
          $loopingVid.each(function () {
            var $thisVid = $(this);
            // Switch the mobile/desktop video sources
            // if needed. Otherwise load video.
            // Need to wait until the metadata is loaded
            // var hasLoaded = false,
            var $vidSource = $thisVid.find('source');

            desktopVidSrc = $thisVid.data('desktop-src');
            mobVidSrc = $thisVid.data('mob-src');
            $thisVid.data({
              desktopSrcActive: false,
              mobSrcActive: false
            });

            // Handle desktop/mobile video source
            // for responsiveness.
            function initVid(src) {
              var domVideo = $thisVid.get(0);

              /* Since the video gets paused on inline tout while sorting, enabling the play again*/
              domVideo.onpause = function () {
                this.muted = true;
                this.play();
              };
              domVideo.onloadeddata = function () {
                if ($thisVid.get(0).readyState > 0) {
                  // Fade in the video once ready.
                  $thisVid.addClass('fadeElemIn');
                  this.muted = true;
                  this.play();
                  $modPicSrs.addClass('fadeElemOut');
                }
              };
              $vidSource.attr('src', src);
              domVideo.load();
            }

            function handleVidSrc() {
              if ($(window).width() >= breakpoint && !$thisVid.data('desktopSrcActive')) {
                initVid(desktopVidSrc || '');
                $thisVid.data({
                  desktopSrcActive: true,
                  mobSrcActive: false
                });
              } else if ($(window).width() < breakpoint && !$thisVid.data('mobSrcActive')) {
                initVid(mobVidSrc || '');
                $thisVid.data({
                  desktopSrcActive: false,
                  mobSrcActive: true
                });
              }
            }
            // On first load, without resizing event:
            handleVidSrc();

            // Listen for window resizing.
            $(window).on('resize', _.debounce(handleVidSrc, 250));
          });
        } else {
          $loopingVidWrapper.remove();
        }

        // Credit positioning - mobile
        var mobileCredit = false;
        var creditPath = $this.find('.headline_content__credit');
        // Store the initial and updated styles.
        var initialStyles = [];
        var newStyles = [];

        if (creditPath.attr('data-pos-mob-top')) {
          mobileCredit = true;
        }

        function handlePositioning() {
          creditPath.each(function () {
            var initialTopStyle = $(this).prop('style')['top'];
            var initialLeftStyle = $(this).prop('style')['left'];

            initialStyles.push(initialTopStyle, initialLeftStyle);

            var mobTopStyle = $(this).data('pos-mob-top');
            var mobLeftStyle = $(this).data('pos-mob-left');

            newStyles.push(mobTopStyle, mobLeftStyle);
          });
        }
        if (mobileCredit) {
          handlePositioning();
        }

        // Store pc/mobile sources as picture tag is not supported.
        function iesrc(eq_val) {
          var $theSrc = $this.find('picture source').eq(eq_val);
          var $ieSrc = $this.find('picture img');
          var imgSrc = $theSrc.attr('srcset');

          $ieSrc.attr('src', imgSrc);
        }

        function handleChanges() {
          if (isIE) {
            iesrc($(window).width() < breakpoint ? 0 : 1);
          }
        }

        // Listen for window resizing.
        $(window).on('resize', _.debounce(handleChanges, 250));

        // On first load, without resizing event:
        handleChanges();
      });
    },
    attach: function (context) {
      // Handle the image source, pc/mobile
      // If IE, handle image sources
      // Check for IE.
      if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
        isIE = true;
      }
      var that = this;

      $('.main-content', context).once(function () {
        var $wrapper = $('.js-product-grid-tout', this);

        that.init($wrapper);
      });
    }
  };
})(jQuery);
